module.exports = __webpack_public_path__ + "static/group-image3-5a2611c856830c81812ae44619c8affd.jpg";